import { PropertyDetails } from "../../../core/api/models/project";
import EditProposedCommercials, { FormattedData } from "./EditProposedCommercials";
import React from "react";

interface ProposedCommercialsProps {
    isEditProposedCommercials: {
        isOpen: boolean;
        data: any;
        propertiesForProject: PropertyDetails[];
    }
    setIsEditProposedCommercials: React.Dispatch<React.SetStateAction<{
        isOpen: boolean;
        data: any;
        propertiesForProject: PropertyDetails[];
    }>>
    setCommercialsEdited: (value: boolean) => void;
    setProposedPropertyData: (value: (prev: any) => any) => void;
    setEditedProposedPropertyData?: (value: (prev: FormattedData[]) => FormattedData[]) => void;
}

const EditProposedCommercialsWrapper: React.FC<ProposedCommercialsProps> = (props) => {

    return (
        <>
            <div className="detail-poupup detail-poupup--sm detail-poupup--mdx detail-poupup--over bg-gray-100 position-fixed top-0 w-100 h-100 overflow-auto in bg-white" style={{
                zIndex: 1053
            }}>
                <div className="container-fluid bg-gray-100 border-bottom py-3">
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <i className="icon-close font-xl cursor-pointer" onClick={() => {
                                props.setIsEditProposedCommercials({
                                    isOpen: false,
                                    data: null,
                                    propertiesForProject: []
                                });
                            }}></i>
                        </div>
                        <div className="co">
                            <h2 className="mb-sm-0 font-base">
                                Edit Proposed Commercials
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="container-fluid bg-white client-approval-form px-1">
                    <div className="px-4 py-4">
                        <EditProposedCommercials isSaving={false} onSubmit={data => {
                            props.setCommercialsEdited(true);
                            props.setProposedPropertyData((prev: any) => {
                                return {
                                    ...prev,
                                    proposalProperties: prev.proposalProperties.map((properties: any) => ({
                                        ...properties,
                                        commericialDetails: properties.propertyId === data.propertyId ? data.commercialDetails : properties.commericialDetails || []
                                    }))
                                };
                            });

                            if (props.setEditedProposedPropertyData) {
                                props.setEditedProposedPropertyData((prev: FormattedData[]) => {
                                    // check if the data is already present if yes replace it or push
                                    const isDataPresent = prev.find(item => item.propertyId === data.propertyId);

                                    if (isDataPresent) {
                                        return prev.map(item => item.propertyId === data.propertyId ? data : item);
                                    }

                                    return [...prev, data];
                                });
                            }

                            props.setIsEditProposedCommercials({
                                isOpen: false,
                                data: null,
                                propertiesForProject: []
                            });
                        }}
                            commericialDetails={props.isEditProposedCommercials.data?.commericialDetails} onClose={() => props.setIsEditProposedCommercials({
                                isOpen: false,
                                data: null,
                                propertiesForProject: []
                            })} firstPropertyDetailsOfGroup={props.isEditProposedCommercials?.data} properties={props.isEditProposedCommercials?.propertiesForProject} />
                    </div>
                </div>
            </div>
            <div
                className="modal-backdrop modal-backdrop--over fade show"
                style={{ zIndex: 1052 }}
            ></div>
        </>
    );
}

export default EditProposedCommercialsWrapper;